namespace TabAurous.Common {
    export interface ShipperSelectForm {
        Freight: Serenity.LookupEditor;
    }

    export class ShipperSelectForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ShipperSelect';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShipperSelectForm.init)  {
                ShipperSelectForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(ShipperSelectForm, [
                    'Freight', w0
                ]);
            }
        }
    }
}
